package kz.dentalcrm.app.screens.service_categories.add

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_service_category_added
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.domain.ServicesRepository
import kz.dentalcrm.app.screens.service_categories.add.mvi.AddServiceCategoryViewEvent
import kz.dentalcrm.app.screens.service_categories.add.mvi.AddServiceCategoryViewSideEffect
import kz.dentalcrm.app.screens.service_categories.add.mvi.AddServiceCategoryViewState
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class AddServiceCategoryViewModel :
    BaseStateViewModel<AddServiceCategoryViewEvent, AddServiceCategoryViewState, AddServiceCategoryViewSideEffect>() {

    private val servicesRepository: ServicesRepository by inject()

    override fun setInitialState() = AddServiceCategoryViewState()

    override fun handleEvents(event: AddServiceCategoryViewEvent) {
        when (event) {
            is AddServiceCategoryViewEvent.AddCategory -> {
                addCategory(event.name)
            }
            AddServiceCategoryViewEvent.Reset -> {
                setState { copy(screenState = AddServiceCategoryViewState.ScreenState.Idle) }
            }
        }
    }

    private fun addCategory(name: String) {
        setState { copy(screenState = AddServiceCategoryViewState.ScreenState.Adding) }
        launch(Dispatchers.Default) {
            when (val result = servicesRepository.addServiceCategory(name)) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_service_category_added), SnackbarEvent.SnackbarType.Green))
                    setState { copy(screenState = AddServiceCategoryViewState.ScreenState.Added) }
                }
                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = AddServiceCategoryViewState.ScreenState.Error(
                                error = result.message ?: "Error adding category"
                            )
                        )
                    }
                }
                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState {
                        copy(
                            screenState = AddServiceCategoryViewState.ScreenState.Error(
                                error = "Unknown error"
                            )
                        )
                    }
                }
            }
        }
    }
}
